export enum StatusEnum {
    OPEN = 'OPEN',
    ACCEPTED = 'ACCEPTED',
    INPROGRESS='INPROGRESS',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS'

  }
